import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import styled, { css } from '@rsos/theme/styled';
import { UNITE_EVENT_PANE_WIDTH } from '../../../constants/dataComponentsDimensions';

const NAVIGATION_HEIGHT = 52; // the nav at the top of the screen

export const EVENT_PANE_MARGIN = 16;

interface StyledEventPaneProps {
  isCollapsed: boolean;
}

export const EventPaneDock = styled.div`
  position: relative;
  flex: 0 0 auto;
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);

  @media (max-width: ${BP_LAPTOP}px) {
    height: auto;
  }
`;

export const StyledEventPane = styled.div<StyledEventPaneProps>`
  display: flex;
  flex-direction: column;
  width: ${UNITE_EVENT_PANE_WIDTH}px;
  flex: 0 0 auto; // Fixes clashing width issues with the map
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);
  z-index: 1; // ASC share dropdown
  background: ${props => props.theme.colors.background};
  interpolate-size: allow-keywords;
  transition:
    height 0.3s ease-in-out,
    border-radius 0.3s ease-in-out;

  ${({ theme }) => {
    // Apply a gradient when the EventPane is in dark(er) mode.
    if (theme.colors.name !== 'light') {
      return `
      background: linear-gradient(
        0deg,
        #0b1928 0%,
        rgba(41,54,72, 0.5) 50%,
        #0b1928 100%
      );
      backdrop-filter: blur(15px);
      `;
    } else {
      return `
      background: linear-gradient(
        0deg,
        #FFFFFF 0%,
        rgba(228, 230, 231, 0.5) 50%,
        #FFFFFF 100%
      );
      backdrop-filter: blur(15px);
      `;
    }
  }}

  ${({ isCollapsed }) => {
    if (isCollapsed) {
      return css`
        position: fixed;
        min-height: 100px;
        height: auto;
        height: calc-size(auto, size); // this only animates in Chrome and Edge
        background: ${({ theme }) => theme.colors.background};
        margin: 8px;
        border-radius: 5px;
      `;
    }
  }}

  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;

export const EventPaneSidePane = styled.div`
  position: absolute;
  left: 100%;
  top: 0;
  width: 420px;
  max-width: calc(100vw - ${UNITE_EVENT_PANE_WIDTH}px - 16px);
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);
  border-left: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  background: ${({ theme }) => theme.colors.background};
  overflow: hidden;
  /* Keep this above map overlays/popovers. */
  z-index: 1000;

  @media (max-width: ${BP_LAPTOP}px) {
    /* On narrow layouts, the EventPane goes full-width, so docked panes don't fit.
       Replace the EventPane content area with a full-width overlay instead. */
    position: fixed;
    left: 0;
    top: ${NAVIGATION_HEIGHT}px;
    width: 100vw;
    max-width: 100vw;
    height: calc(100vh - ${NAVIGATION_HEIGHT}px);
    border-left: none;
  }
`;

export const EventPaneSidePaneHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
`;

export const EventPaneSidePaneBody = styled.div`
  padding: 16px;
  box-sizing: border-box;
  height: calc(100% - 52px);
  overflow-y: auto;
`;
